<div class="wd-backdrop" (click)="dismiss()"></div>

<div class="wd">
  <!-- Hero band -->
  <div class="wd__hero" [ngClass]="{'wd__hero--success': isSuccess, 'wd__hero--pending': isPending, 'wd__hero--failed': isFailed}">
    <div class="wd__hero-bg"></div>
    <button class="wd__close" (click)="dismiss()"><i class="fa fa-times"></i></button>

    <div class="wd__logo">
      <img src="assets/images/staffy-logo-icon.png" alt="">
    </div>

    <div class="wd__amount">
      <span class="wd__dollar">$</span>{{ transaction.amount }}
    </div>

    <span class="wd__badge">{{ statusLabel }}</span>
  </div>

  <!-- Details -->
  <div class="wd__body">
    <div class="wd__row">
      <span class="wd__label">Type</span>
      <span class="wd__value">{{ isDeposit ? 'Deposit' : 'Withdrawal' }}</span>
    </div>
    <div class="wd__row">
      <span class="wd__label">Date</span>
      <span class="wd__value">{{ formattedDate }}</span>
    </div>
    <div class="wd__row">
      <span class="wd__label">Time</span>
      <span class="wd__value">{{ formattedTime }}</span>
    </div>

    <div class="wd__row" *ngIf="withdrawalFee > 0">
      <span class="wd__label">Same-day fee</span>
      <span class="wd__value">-${{ withdrawalFee.toFixed(2) }}</span>
    </div>
    <div class="wd__row" *ngIf="withdrawalFee > 0 && !isFailed">
      <span class="wd__label">{{ isPending ? 'You will receive' : 'You received' }}</span>
      <span class="wd__value">${{ netAmount }}</span>
    </div>

    <div class="wd__desc" *ngIf="transaction.description">
      <span class="wd__desc-label">Note</span>
      <p class="wd__desc-text">{{ transaction.description }}</p>
    </div>

    <button class="wd__btn" (click)="dismiss()">Done</button>
  </div>
</div>
